import type { ThemeOptions } from '@mui/material';

import { body } from '../../../constants/fonts';
import { Breakpoint } from '../../../theme/breakpoints';
import Palette from '../../../theme/palette';
import { shadows } from '../../../theme/shadows';

export const tableThemeOptions: ThemeOptions = {
  components: {
    MUIDataTable: {
      styleOverrides: {
        // @ts-expect-error Prop missing from type def
        responsiveBase: ({ theme }) => ({
          background: theme.palette.background.paper,
          borderRadius: '5px',
          boxShadow: shadows[1],
        }),
        paper: {
          width: '100%',
          background: 'none',
          boxShadow: 'none',
          paddingLeft: 0,
          paddingRight: 0,
        },
        tableRoot: {
          overflow: 'hidden',
        },
      },
    },
    MUIDataTableBody: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.paper,
        }),
        lastStackedCell: ({ theme }) => ({
          backgroundColor: theme.palette.background.paper,
        }),
      },
    },
    MUIDataTableBodyCell: {
      styleOverrides: {
        root: {
          maxWidth: '75%',
          [`@media (min-width: ${Breakpoint.SM}px)`]: {
            maxWidth: 'unset',
          },
        },
        stackedHeader: {
          display: 'none !important',
        },
        responsiveStackedSmallParent: {
          border: 'none',
        },
      },
    },
    MUIDataTableBodyRow: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.paper,
        }),
        responsiveStacked: {
          border: 'none',
          cursor: 'pointer',
        },
      },
    },
    MUIDataTableFilter: {
      styleOverrides: {
        root: {
          '& *': { fontFamily: body },
        },
        header: {
          marginBottom: '32px',
        },
        gridListTile: {
          marginTop: 0,
          '& > .MuiFormControl-root': {
            '& > .MuiInput-root': {
              marginTop: 0,
              '&:before': {
                border: 'none !important',
              },
              '&::before': {
                border: 'none !important',
              },
              '&:after': {
                border: 'none !important',
              },
              '&::after': {
                border: 'none !important',
              },
            },
            '& > .MuiInputLabel-root': {
              position: 'relative',
              transition: 'none',
              transform: 'none',
            },
          },
        },
      },
    },
    MUIDataTableFilterList: {
      styleOverrides: {
        root: {
          paddingLeft: '5px',
          paddingBottom: '8px',
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          background: 'none',
          boxShadow: 'none',
          minHeight: '50px !important',
          paddingLeft: '5px !important',
          paddingRight: '5px !important',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h6: {
          fontSize: '15px',
          margin: 0,
          marginLeft: '6px',
          padding: 0,
          fontWeight: 'bold',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${Palette.light.grey?.A200}`,
        },
        head: {
          paddingTop: '13px',
          paddingBottom: '13px',
          paddingLeft: '5px',
          paddingRight: 0,
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: 'outlined',
      },
    },
    MuiGrid: {
      styleOverrides: {
        item: {
          paddingTop: '0 !important',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        root: {
          maxHeight: '300px',
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          maxHeight: '90vh',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          margin: '0 0 15px 0',
        },
      },
    },
  },
};
